import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-enterprise";
import {
  accountTypeIcon,
  localBasiqLogoPath,
} from "@bitwarden/web-vault/app/models/types/account-display.utils";
import { UserStoreService } from "@bitwarden/web-vault/app/services/store/user/user.store.service";

@Component({
  selector: "app-account-row-renderer",
  templateUrl: "./account-row-renderer.component.html",
  standalone: true,
  imports: [CommonModule],
})
export class AccountRowRendererComponent implements ICellRendererAngularComp {
  private userStore = inject(UserStoreService);
  params: ICellRendererParams;
  icon: string;
  square_logo_url: string;
  full_logo_url: string;
  name: string;
  balance: number;
  currency: string;
  institution: string;
  interestRate: number;
  accountProductName: string;

  get isEyeOpen(): boolean {
    return this.userStore.showBalance() || false;
  }

  agInit(params: ICellRendererParams): void {
    this.assignParams(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.assignParams(params);
    return true;
  }

  private assignParams(params: ICellRendererParams): void {
    this.params = params;
    this.icon = accountTypeIcon(params.data?.type);
    this.name = params.data?.name;
    this.balance = params.data?.balance;
    this.currency = params.data?.symbol;
    this.institution = params.data?.institution;
    this.interestRate = params.data?.interestRate;
    this.accountProductName = params.data?.accountProductName;
    this.full_logo_url = params.data?.full_logo_url;

    this.getSqrLogoFileName(params.data?.square_logo_url).then((url) => {
      if (this.params === params) {
        this.square_logo_url = url;
      }
    });
  }

  isValidNumber(value: number): boolean {
    return !isNaN(value) && value !== null && value !== undefined;
  }

  async getSqrLogoFileName(logoUrl: string): Promise<string> {
    const localImagePath = localBasiqLogoPath(logoUrl);
    if (!localImagePath) {
      return "";
    }

    const isImageInFs = await this.isImageInFileSys(localImagePath);
    return isImageInFs ? localImagePath : "";
  }

  private isImageInFileSys(imagePath: string): Promise<boolean> {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = imagePath;

      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
    });
  }
}
